import axios, { AxiosRequestConfig } from "axios"
import config from "../config"
import { setupBoldBIInterceptor, setupCustomInterceptor, setupInterceptors } from "./interceptors"

const baseReqConfig: AxiosRequestConfig = {
    baseURL: config.BASE_API_URL,
    headers: {
        Accept: 'Application/json',
        'Content-Type': 'Application/json'
    },
}

const ruleEngineReqConfig: AxiosRequestConfig = {
    baseURL: config.GEOSERVER_VALIDATION_FLAG,
    headers: {
        Accept: 'Application/json',
        'Content-Type': 'Application/json'
    },
}

const mlPredReqConfig: AxiosRequestConfig = {
    baseURL: config.ML_PREDICTION,
    headers: {
        Accept: 'Application/json',
        'Content-Type': 'Application/json'
    },
}

const baseReqConfigWithBoldbi: AxiosRequestConfig = {
    baseURL: config.BASE_API_URL,
    headers: {
        Accept: 'Application/json',
        'Content-Type': 'Application/json'
    },
}

const boldBIReqConfig: AxiosRequestConfig = {
    baseURL: config.BOLD_BI_API_URL,
    headers: {
        Accept: 'Application/json',
        'Content-Type': 'Application/json'
    },
}

const baseReqConfigFiles: AxiosRequestConfig = {
    baseURL: config.BASE_API_URL,
    responseType: 'arraybuffer',
    headers: {
        Accept: 'Application/json',
    },
}

export const baseInstance = setupInterceptors(axios.create(baseReqConfig))
export const ruleEngineInstance = setupInterceptors(axios.create(ruleEngineReqConfig))
export const mlPredInstance = setupInterceptors(axios.create(mlPredReqConfig))
export const baseInstanceWithBoldBI = setupCustomInterceptor(axios.create(baseReqConfigWithBoldbi))
export const boldBIInstance = setupBoldBIInterceptor(axios.create(boldBIReqConfig))
export const baseInstanceExcel = setupCustomInterceptor(axios.create(baseReqConfigFiles))